import { h, Component } from 'preact';
// import Store from 'store/store';
// import { accessNested } from 'utils/utils';

export default class Link extends Component {
	// addExternalLinkModal(attributes) {
	// 	const prevOnClick = attributes.onClick;
	// 	attributes.onClick = (e) => {
	// 		e.stopPropagation();
	// 		e.preventDefault();
	// 		Store.emit('DISPLAY_EXTERNAL_LINK_MODAL', {
	// 			originalEvent: e,
	// 			onClick: prevOnClick,
	// 			target: attributes.target,
	// 			href: attributes.href
	// 		});
	// 		return false;
	// 	};
	// 	return attributes;
	// }

	render({ children, ...attributes }) {
		// const appData = Store.get().appData;
		// const hasExternalLinkModal = accessNested(appData, 'options.externalLinkModal', false) && !attributes.ignoreExternalLinkModal;
		// const isExternalLink = attributes.href && /^(https?:)?\/\//.test(attributes.href);
		// if (hasExternalLinkModal && isExternalLink) {
		// 	attributes = this.addExternalLinkModal(attributes);
		// }

		return (
			<a {...attributes}>{children}</a>
		);
	}
}
